import { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { State } from '../../../reducers';
import { ErrorScreen } from './ErrorScreen';
import { UseLpStakingPool } from '../hooks/usePool';
import { ClaimConfirm } from './ClaimScreen';
import { SuccessfulClaimLP } from './ClaimSuccess';
import { InitialScreen } from './Screen1';
import { LpStakeScreen } from './StakeScreen';
import { SuccessfulStakeLP } from './StakeSuccess';
import { UnstakeScreen } from './UnstakeScreen';
import { UnstakeLPSuccess } from './UnstakeSuccess';
import { WithdrawConfirm } from './WithdrawScreen';
import { SuccessfulWithdrawLp } from './WithdrawSuccess';
import { LpScreenEnum } from './_Screens';
import { TransactionHistoryLp } from './TransactionHistory';
import { SideBarHeaderLP } from '../components/HeaderLp';

interface SidebarBodyProps {
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
}

interface ErrorProps {
  code?: number | string | null | undefined;
  message?: string | undefined;
}

const StyledSidebarWrapper = styled.div`
  padding: 1.5rem;
`;

export function ViewLPStakeBody({ setShow }: SidebarBodyProps) {
  const [message, setMessage] = useState<ErrorProps>({});
  const [screen, setScreen] = useState<LpScreenEnum>(LpScreenEnum.HOME_SCREEN);
  const [stakeAmount, setStakeAmount] = useState('');
  const [unstakeAmount, setUnstakeAmount] = useState('');
  const [claimedAmount, setClaimedAmount] = useState('');
  const [withdrawnAmount, setWithdrawnAmount] = useState('');

  const { walletNetwork } = useSelector(({ account }: State) => ({
    walletNetwork: account.networkId,
  }));

  const pool = UseLpStakingPool();

  const { stakingTokenSymbol, token0Symbol, token1Symbol, isZen } = pool;

  const renderBody = () => {
    switch (screen) {
      case LpScreenEnum.HOME_SCREEN:
        return (
          <>
            <SideBarHeaderLP
              token0={token0Symbol}
              token1={token1Symbol}
              symbol={stakingTokenSymbol}
              isZen={isZen}
              zenSymbol={stakingTokenSymbol}
              title={'Staking'}
            />
            <InitialScreen walletNetworkId={walletNetwork} setScreen={setScreen} />
          </>
        );

      case LpScreenEnum.STAKE_SCREEN:
        return (
          <>
            <SideBarHeaderLP
              token0={token0Symbol}
              token1={token1Symbol}
              symbol={stakingTokenSymbol}
              isZen={isZen}
              zenSymbol={stakingTokenSymbol}
              title={'Stake'}
            />
            <LpStakeScreen
              walletNetworkId={walletNetwork || 1}
              setScreen={setScreen}
              setMessage={setMessage}
              stakeAmount={stakeAmount}
              setStakeAmount={setStakeAmount}
            />
          </>
        );
      case LpScreenEnum.UNSTAKE_SCREEN:
        return (
          <>
            <SideBarHeaderLP
              token0={token0Symbol}
              token1={token1Symbol}
              symbol={stakingTokenSymbol}
              isZen={isZen}
              zenSymbol={stakingTokenSymbol}
              title={'Unstake'}
            />

            <UnstakeScreen
              setScreen={setScreen}
              walletNetworkId={walletNetwork || 1}
              unstakeAmount={unstakeAmount}
              setUnstakeAmount={setUnstakeAmount}
            />
          </>
        );
      case LpScreenEnum.STAKE_SUCCESS:
        return (
          <>
            <SideBarHeaderLP
              token0={token0Symbol}
              token1={token1Symbol}
              symbol={stakingTokenSymbol}
              isZen={isZen}
              zenSymbol={stakingTokenSymbol}
              title={'Staking success'}
            />
            <SuccessfulStakeLP stakeAmount={stakeAmount} setScreen={setScreen} setShow={setShow} />
          </>
        );
      case LpScreenEnum.CLAIM_CONFIRM:
        return (
          <>
            <SideBarHeaderLP
              token0={token0Symbol}
              token1={token1Symbol}
              symbol={stakingTokenSymbol}
              isZen={isZen}
              zenSymbol={stakingTokenSymbol}
              title={'Withdrawal'}
            />
            <ClaimConfirm setScreen={setScreen} setClaimedAmount={setClaimedAmount} />
          </>
        );
      case LpScreenEnum.UNSTAKE_SUCCESS:
        return (
          <>
            <SideBarHeaderLP
              token0={token0Symbol}
              token1={token1Symbol}
              symbol={stakingTokenSymbol}
              isZen={isZen}
              zenSymbol={stakingTokenSymbol}
              title={'Unstake success'}
            />

            <UnstakeLPSuccess
              unstakeAmount={unstakeAmount}
              setScreen={setScreen}
              setShow={setShow}
            />
          </>
        );
      case LpScreenEnum.CLAIM_SUCCESS:
        return (
          <>
            <SideBarHeaderLP
              token0={token0Symbol}
              token1={token1Symbol}
              symbol={stakingTokenSymbol}
              isZen={isZen}
              zenSymbol={stakingTokenSymbol}
              title={'Unstake success'}
            />
            <SuccessfulClaimLP
              claimedAmount={claimedAmount}
              setScreen={setScreen}
              setShow={setShow}
            />
          </>
        );
      case LpScreenEnum.WITHDRAW_CONFIRM:
        return (
          <>
            <SideBarHeaderLP
              token0={token0Symbol}
              token1={token1Symbol}
              symbol={stakingTokenSymbol}
              isZen={isZen}
              zenSymbol={stakingTokenSymbol}
              title={'Unstake success'}
            />
            <WithdrawConfirm setScreen={setScreen} setWithdrawnAmount={setWithdrawnAmount} />
          </>
        );
      case LpScreenEnum.WITHDRAW_SUCCESS:
        return (
          <>
            <SideBarHeaderLP
              token0={token0Symbol}
              token1={token1Symbol}
              symbol={stakingTokenSymbol}
              isZen={isZen}
              zenSymbol={stakingTokenSymbol}
              title={'Unstake success'}
            />
            <SuccessfulWithdrawLp
              setShow={setShow}
              setScreen={setScreen}
              withdrawnAmount={withdrawnAmount}
            />
          </>
        );
      case LpScreenEnum.ERROR:
        return (
          <>
            <SideBarHeaderLP
              token0={token0Symbol}
              token1={token1Symbol}
              symbol={stakingTokenSymbol}
              isZen={isZen}
              zenSymbol={stakingTokenSymbol}
              title={'Error'}
            />
            <ErrorScreen message={message} setShow={setShow} setScreen={setScreen} />
          </>
        );
      case LpScreenEnum.TRANSACTION_HISTORY:
        return (
          <>
            <SideBarHeaderLP
              token0={token0Symbol}
              token1={token1Symbol}
              symbol={stakingTokenSymbol}
              isZen={isZen}
              zenSymbol={stakingTokenSymbol}
              title={'Transaction history'}
            />
            <TransactionHistoryLp setScreen={setScreen} />
          </>
        );
    }
  };

  return <StyledSidebarWrapper>{renderBody()}</StyledSidebarWrapper>;
}
